import { Heading } from "theme-ui";
import { TitleWithClippedGradient } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Heading,
  TitleWithClippedGradient,
  React
};